'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useRenderElement } from '@mui/x-scheduler-headless/base-ui-copy';
import { schedulerOccurrenceSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { eventTimelinePremiumViewSelectors } from "../../event-timeline-premium-selectors/index.mjs";
import { TimelineGridRootCssVars } from "./TimelineGridRootCssVars.mjs";
export const TimelineGridRoot = /*#__PURE__*/React.forwardRef(function TimelineGridRoot(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // Context hooks
  const store = useEventTimelinePremiumStoreContext();

  // Selector hooks
  const viewConfig = useStore(store, eventTimelinePremiumViewSelectors.config);
  const resources = useStore(store, schedulerOccurrenceSelectors.groupedByResourceList, viewConfig.start, viewConfig.end);
  const props = {
    role: 'grid',
    style: {
      [TimelineGridRootCssVars.unitCount]: viewConfig.unitCount,
      [TimelineGridRootCssVars.rowCount]: resources.length
    }
  };
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridRoot.displayName = "TimelineGridRoot";